import { type ClipSpriteSheet } from '@air/api/types';

/**
 * Gets the frame count of the spritesheet based on the columns and rows of the spritesheet.
 * @param spritesheet
 * @returns the frame count of the sprite sheet
 */
export const getClipSpritesheetFrameCount = (spritesheet: ClipSpriteSheet | undefined) => {
  if (!spritesheet) {
    return 0;
  }

  return spritesheet.columns * spritesheet.rows;
};
